import { JsonLdService } from './json-ld.service';
import { NgModule } from '@angular/core';

@NgModule({
  providers: [
    JsonLdService,
  ],
})

export class BrowserJsonLdModule { }
